import styled from "styled-components";

// tslint:disable-next-line
export const ActionMenuCloseContainer = styled.div`
  position: absolute;
  right: 5px;
  top: 0;
  display: inline-block;
`;
